import { useEffect, useState } from "react";
import { Helmet } from "react-helmet-async";
import { Star } from "lucide-react";
import api from "@/lib/api";

const Stars = ({ n }) => (
  <span className="inline-flex items-center gap-0.5">
    {[1, 2, 3, 4, 5].map((i) => (
      <Star key={i} className={`h-4 w-4 ${i <= Math.round(n) ? "text-amber-400" : "text-zinc-700"}`} fill={i <= Math.round(n) ? "currentColor" : "none"} />
    ))}
  </span>
);

export default function ReviewsWall() {
  const [data, setData] = useState(null);
  useEffect(() => {
    api.get("/reviews/public").then((r) => setData(r.data)).catch(() => {});
  }, []);
  if (!data || !data.count) return null;

  const ld = {
    "@context": "https://schema.org",
    "@type": "SoftwareApplication",
    name: "Videoileo",
    applicationCategory: "MultimediaApplication",
    operatingSystem: "Web",
    url: "https://www.videoileo.com/",
    offers: { "@type": "Offer", price: "0", priceCurrency: "USD" },
    aggregateRating: { "@type": "AggregateRating", ratingValue: data.average, ratingCount: data.count, bestRating: 5, worstRating: 1 },
    review: data.reviews.slice(0, 6).map((r) => ({
      "@type": "Review",
      author: { "@type": "Person", name: r.name },
      reviewRating: { "@type": "Rating", ratingValue: r.stars, bestRating: 5 },
      reviewBody: r.comment,
    })),
  };

  return (
    <section className="py-24 px-5 border-t border-white/10" data-testid="reviews-section">
      <Helmet>
        <script type="application/ld+json">{JSON.stringify(ld)}</script>
      </Helmet>
      <div className="max-w-6xl mx-auto">
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-4 mb-10">
          <div>
            <p className="text-xs uppercase tracking-[0.2em] text-zinc-500 mb-2">Reviews</p>
            <h2 className="font-head text-lg md:text-3xl font-bold tracking-tight">Loved by creators</h2>
          </div>
          <div className="flex items-center gap-3" data-testid="reviews-aggregate">
            <Stars n={data.average} />
            <span className="text-sm text-zinc-400">
              <span className="text-white font-semibold">{data.average}</span> / 5 · {data.count} review{data.count === 1 ? "" : "s"}
            </span>
          </div>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
          {data.reviews.slice(0, 6).map((r, i) => (
            <div key={i} className="border border-white/10 rounded-md bg-[#121212] p-5 hover:border-white/20 transition-colors" data-testid={`review-card-${i}`}>
              <Stars n={r.stars} />
              <p className="text-sm text-zinc-300 mt-3 leading-relaxed">“{r.comment}”</p>
              <p className="text-xs text-zinc-500 mt-4 font-medium">— {r.name}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
